import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'rm-snippet',
  template: `
    <h5 class="snippet-title">{{title}}</h5>
    <codemirror [(ngModel)]="content"
                [config]="config">
    </codemirror>
  `,
  styleUrls: ['./snippet.component.scss']
})
export class SnippetComponent implements OnInit {
  @Input() config: any;
  @Input() content: string;
  @Input() title: string;

  ngOnInit() {
    this.config = {
      name: "javascript",
      theme: "monokai",
      autoFormatOnStart: true,
      matchBrackets: true,
      lineNumbers: true,
      readOnly: true
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/snippet/snippet.component.ts